import mapboxgl from 'mapbox-gl';

export const addTSOZoneLayers = (map: mapboxgl.Map, geoJSONData: any, theme: string) => {
  // Add source for TSO zones
  map.addSource('tso-zones', {
    type: 'geojson',
    data: geoJSONData,
  });

  // Add fill layer for TSO zones
  map.addLayer({
    id: 'tso-zones-fill',
    type: 'fill',
    source: 'tso-zones',
    paint: {
      'fill-color': [
        'case',
        ['boolean', ['feature-state', 'selected'], false],
        '#EC4899', // Jua pink for selected zones
        ['boolean', ['feature-state', 'hovered'], false],
        '#EC4899', // Same pink for hovered zones
        '#3B82F6', // Blue for unselected zones
      ],
      'fill-opacity': [
        'case',
        ['boolean', ['feature-state', 'selected'], false],
        0.6, // Selected zones with 60% opacity
        ['boolean', ['feature-state', 'hovered'], false],
        0.4, // Hovered zones with 40% opacity (lighter than selected)
        0.3, // Default with 30% opacity
      ],
    },
  });

  // Add border layer for TSO zones
  map.addLayer({
    id: 'tso-zones-border',
    type: 'line',
    source: 'tso-zones',
    paint: {
      'line-color': [
        'case',
        ['boolean', ['feature-state', 'selected'], false],
        '#EC4899', // Jua pink for selected zones
        ['boolean', ['feature-state', 'hovered'], false],
        '#EC4899', // Same pink for hovered zones
        theme === 'dark' ? '#6B7280' : '#374151',
      ],
      'line-width': [
        'case',
        ['boolean', ['feature-state', 'selected'], false],
        3, // Selected zones with thicker border
        ['boolean', ['feature-state', 'hovered'], false],
        2, // Hovered zones with medium border
        1, // Default border width
      ],
      'line-opacity': 1.0,
    },
  });
};

export const updateLayerTheme = (map: mapboxgl.Map, theme: string) => {
  if (map.getLayer('tso-zones-border')) {
    map.setPaintProperty('tso-zones-border', 'line-color', [
      'case',
      ['boolean', ['feature-state', 'selected'], false],
      '#EC4899', // Jua pink for selected zones
      ['boolean', ['feature-state', 'hovered'], false],
      '#EC4899', // Same pink for hovered zones
      theme === 'dark' ? '#6B7280' : '#374151',
    ]);
  }
};
